import { useEffect, useRef } from 'react'
import { appendToSearchHistory } from '@moonpig/web-core-app-shell-search'
import {
  CookieCategory,
  useOneTrustConsentCategory,
} from '@moonpig/web-core-browser-storage'
import { PageTypeEnum } from '@moonpig/web-shared-products'
import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'
import type { SelectedSuggestion } from '../../components/types'

type UseAppendSearchHistoryProps = {
  pageType: PageTypeEnum
  department: DepartmentsEnum[]
  searchTerm: string
  suggestionKey?: string
  selectedSuggestion?: SelectedSuggestion
  totalCount: number
}

export const useAppendSearchHistory = ({
  pageType,
  department,
  searchTerm,
  suggestionKey,
  selectedSuggestion,
  totalCount,
}: UseAppendSearchHistoryProps): void => {
  const appendedForRef = useRef<string | null>(null)
  const hasFunctionalConsent = useOneTrustConsentCategory(
    CookieCategory.FUNCTIONAL,
  )

  useEffect(() => {
    if (
      pageType !== PageTypeEnum.SEARCH ||
      totalCount === 0 ||
      !hasFunctionalConsent
    ) {
      return
    }

    const term = searchTerm.trim() || selectedSuggestion?.label?.trim()

    if (!term) {
      return
    }

    const searchReferenceKey = `${term}|${suggestionKey ?? ''}`

    if (appendedForRef.current === searchReferenceKey) {
      return
    }

    appendedForRef.current = searchReferenceKey

    appendToSearchHistory({
      searchTerm: term,
      searchKey: suggestionKey,
      department: department[0].toLowerCase(),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    hasFunctionalConsent,
    pageType,
    searchTerm,
    suggestionKey,
    selectedSuggestion?.label,
  ])
}
